package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.section.DesktopNavigationAnchor
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import org.jetbrains.compose.web.css.px

@Composable
fun ZoneArrow(
    pageName: String,
    largeTitle: Boolean = false
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 20.px,bottom = if(breakpoint <= Breakpoint.MD) 0.px else 40.px)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .zIndex(3)
                .margin(top = if (breakpoint == Breakpoint.LG) 20.px else if (breakpoint > Breakpoint.MD) 60.px else 0.px)
                .padding(bottom = if (breakpoint == Breakpoint.LG) 0.px else if (breakpoint > Breakpoint.MD) 10.px else 20.px),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (breakpoint > Breakpoint.MD) {
                Box(
                    modifier = Modifier,
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        modifier = Modifier
                            .width(if (largeTitle) 400.px else 343.px),
                        src = Res.Image.zone_arrow,
                        description = "Arrow"
                    )
                    Row(
                        modifier = Modifier
                            .width(400.px)
                            .margin(left = if (largeTitle) 110.px else 140.px)
                            .padding(bottom = 8.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.Start
                    ) {
                        DesktopNavigationAnchor("/", Modifier) {
                            FieldTitleTextNormalSimple(
                                text = "Home",
                                color = sitePalette.commonSecondaryButtonColor.rgb,
                                fontSize = 20.px,
                                fontWeight = 500,
                                isClickable = true,
                            )
                        }
                        Box(modifier = Modifier.height(20.px)
                            .width(1.px)
                            .margin(leftRight = 15.px)
                            .backgroundColor(Colors.LightGray))
                        DesktopNavigationAnchor("/portfolio", Modifier) {
                            FieldTitleTextNormalSimple(
                                text = "Portfolio",
                                color = sitePalette.commonSecondaryButtonColor.rgb,
                                fontSize = 20.px,
                                fontWeight = 500,
                                isClickable = true,
                            )
                        }
                        Box(modifier = Modifier.height(20.px)
                            .width(1.px)
                            .margin(leftRight = 15.px)
                            .backgroundColor(Colors.LightGray))
                        FieldTitleTextNormalSimple(
                            text = pageName,
                            color = sitePalette.primary.rgb,
                            fontSize = 20.px,
                            fontWeight = 500
                        )
                    }
                }
            }
        }
    }
}

